import React from 'react';
import Text from '.';

const TitleBold = ({text, size, color, ownClass}) => {
    return(
        <Text 
            ownClass={`title-bold ${ownClass}`}
            text={text}
            size={size}
            color={color}/>
    )
}

export default TitleBold;